import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const SectionWrapper = styled.div.attrs({
  className: 'Category_Link',
})`
  background: #ffffff;
  border: 0;
  box-shadow: 0px 3px 6px ${themed('primary.gray')};
  border-radius: 5px;
  padding: 1rem;
  text-align: center;

  .Thumbnail {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;

    .component__roundedIcon {
      background-color: ${(props) => props.color};
      cursor: pointer;
    }
  }

  .Title {
    color: ${themed('primary.accent')};
    cursor: pointer;
    font-size: 1rem;
  }
`;
